import { isBefore, isValid, sub } from 'date-fns';
import * as yup from 'yup';

// Copied from PersonalDetailsDE.schema.ts — keep in sync if the desktop rule changes.
const dayRegex = /^(0?[1-9]|[12][0-9]|3[01])$/;
const monthRegex = /^(?:0?[1-9]|1[012])$/;

const toDate = (year: string, month: string, day: string) =>
  new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

// JS Date silently rolls invalid days over (31 Feb → 3 Mar), so a real-date
// check verifies the components round-trip rather than trusting construction.
const isRealDate = (year: string, month: string, day: string) => {
  const date = toDate(year, month, day);
  return (
    isValid(date) &&
    date.getFullYear() === parseInt(year) &&
    date.getMonth() === parseInt(month) - 1 &&
    date.getDate() === parseInt(day)
  );
};

const isOver18 = (year: string, month: string, day: string) => {
  const date18YearsAgo = sub(new Date(), { years: 18 });
  return isBefore(toDate(year, month, day), date18YearsAgo);
};

export const dateOfBirthSchema = yup.object().shape({
  dobDay: yup
    .string()
    .required('benötigt')
    .matches(dayRegex, 'ungültige Eingabe'),
  dobMonth: yup
    .string()
    .required('benötigt')
    .matches(monthRegex, 'ungültige Eingabe'),
  dobYear: yup
    .string()
    .required('benötigt')
    .min(4, 'benötigt')
    .max(4, 'ungültige Eingabe')
    .test('real-date', 'ungültige Eingabe', function (value, ctx) {
      if (!Number(ctx.parent.dobMonth) || !Number(ctx.parent.dobDay))
        return true;
      return isRealDate(
        value as string,
        ctx.parent.dobMonth,
        ctx.parent.dobDay,
      );
    })
    .test('Is 18 or over', 'Mindestalter 18 Jahre', function (value, ctx) {
      if (!Number(ctx.parent.dobMonth) || !Number(ctx.parent.dobDay))
        return true;
      if (!isRealDate(value as string, ctx.parent.dobMonth, ctx.parent.dobDay))
        return true; // real-date test already reports this
      return isOver18(value as string, ctx.parent.dobMonth, ctx.parent.dobDay);
    }),
});
